import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";

function Form101SubmittedTimeOutDialog({ formOpen, onConfirm }) {
    const { t, i18n } = useTranslation();

    return (
        <React.Fragment>
            <Dialog aria-labelledby="simple-dialog-title" open={formOpen}>
                <DialogTitle id="simple-dialog-title">
                    {t("Form101.errorMsg.submitFail")}
                </DialogTitle>
                <DialogContent>
                    {t("Form101.errorMsg.submitTimeout")}
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={onConfirm} color="success">
                        <b>{t("common.portal.close")}</b>
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
export default Form101SubmittedTimeOutDialog;
